import { Button } from "@progress/kendo-react-buttons";

interface GxRedRejectButtonSmallProp {
  onClick: () => void;
  children?: string;
  disabled?: boolean;
}

const GxRedRejectButtonSmall = ({
  onClick,
  children,
}: GxRedRejectButtonSmallProp) => {
  return (
    <Button
      onClick={onClick}
      className="gx-dialog-button-red-small gx-submit-for-approval-small"
    >
      <span className="gx-h4-small">{children || ""}</span>
    </Button>
  );
};

export default GxRedRejectButtonSmall;
